import React from 'react';
import SvgIcon from './SvgIcon';

function RefreshIcon({ width }) {
    return (
        <SvgIcon className="RefreshIcon" width={width}>
            <svg
                width="100%"
                height="100%"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g id="icon/refresh">
                    <path
                        id="color"
                        d="M9.02893 14.625C7.45856 14.625 6.12849 14.0802 5.03874 12.9906C3.94887 11.9009 3.40393 10.5711 3.40393 9.00113C3.40393 7.43113 3.94887 6.10094 5.03874 5.01056C6.12849 3.92019 7.45856 3.375 9.02893 3.375C9.90581 3.375 10.7356 3.56994 11.5184 3.95981C12.301 4.34981 12.9519 4.90006 13.4712 5.61056V3.375H14.5962V7.96144H10.0097V6.83663H12.9722C12.577 6.1125 12.0289 5.54206 11.3279 5.12531C10.627 4.70844 9.86068 4.5 9.02893 4.5C7.77893 4.5 6.71643 4.9375 5.84143 5.8125C4.96643 6.6875 4.52893 7.75 4.52893 9C4.52893 10.25 4.96643 11.3125 5.84143 12.1875C6.71643 13.0625 7.77893 13.5 9.02893 13.5C9.99143 13.5 10.8602 13.225 11.6352 12.675C12.4102 12.125 12.9539 11.4 13.2664 10.5H14.452C14.1116 11.724 13.4412 12.7175 12.4407 13.4805C11.4402 14.2435 10.3029 14.625 9.02893 14.625Z"
                        fill="white"
                    />
                </g>
            </svg>
        </SvgIcon>
    );
}

export default RefreshIcon;
